import { TextTestID } from "@/constants/TestID";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface ChannelListHeaderProps extends BaseViewProps {
  title: string;
}

const ChannelListHeader = ({ testID, title }: ChannelListHeaderProps) => {
  const baseTestID = joinTestIDs(testID, "section", TextTestID.Header);

  return (
    <Box
      alignItems="center"
      backgroundColor={ColorToken.NeutralBackgroundPrimary}
      flexDirection="row"
      justifyContent="space-between"
      paddingHorizontal={16}
      paddingVertical={8}
      testID={testID}
    >
      <Text
        color={ColorToken.NeutralSecondary}
        testID={baseTestID}
        variant="caption"
      >
        {title}
      </Text>
    </Box>
  );
};

export default ChannelListHeader;
